module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": '740px',
      "set-class": "no-padding"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', [_vm._v("Välj ålder och datum")]), _vm._v(" "), _c('p', {
    staticClass: "subtext"
  }), _vm._v(" "), _c('SkiSchoolFilter', {
    attrs: {
      "start-view": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "blocked center"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.validated
    },
    on: {
      "click": function($event) {
        return _vm.startBooking()
      }
    }
  }, [_vm._v("Visa Skidskolor "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.2
    }
  })], 1)]), _vm._v(" "), (_vm.SITE_CONFIG.skischool.show_site) ? _c('div', {
    staticClass: "blocked info"
  }, [_c('b', [_c('icon', {
    attrs: {
      "name": "map",
      "scale": 1.4
    }
  }), _vm._v(" Samlingsplatser")], 1), _vm._v(" "), _c('p', [_vm._v("Samlingsplatser för skidskolan väljer man vid bokningen. Skidskolor för nybörjare utgår från både Byn och Berget. Fortsättningsgrupperna samlas vid starten av Storbacken.")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d5a0b09"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiSchoolPicker.vue
// module id = 899
// module chunks = 0